var _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 14,
    viewBox: "0 0 32 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.80952,
    cy: 10.1904,
    r: 3.80952,
    fill: "url(#paint0_linear_4_2995)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 4.09468,
    r: 3.80952,
    fill: "url(#paint1_linear_4_2995)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1904,
    cy: 10.1904,
    r: 3.80952,
    fill: "url(#paint2_linear_4_2995)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_2995",
    x1: 0,
    y1: 10.1904,
    x2: 7.61905,
    y2: 10.1904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED0687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6C0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_2995",
    x1: 12.1904,
    y1: 4.09468,
    x2: 19.8095,
    y2: 4.09468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED0687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6C0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_2995",
    x1: 24.3809,
    y1: 10.1904,
    x2: 31.9999,
    y2: 10.1904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED0687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6C0F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoot);
export default __webpack_public_path__ + "static/media/foot.ce814e31dd375b606b2c923a2718202e.svg";
export { ForwardRef as ReactComponent };